$(function() {
  $('.point-goods__image--item img').on('click touchstart mouseover', function(event) {
    var $mainImage = $('.point-goods__image--main img');
    var $selectedImage = $(this);

    $mainImage.replaceWith($selectedImage.clone());
  });

  $('.dl_point_enquete_01,.dl_point_enquete_02').wrapAll('<div class="point_enquete">');
  $('.point_enquete').prepend('<h3 class="point_enquete-head">アンケート<span class="required">必須</span></h3>');

  // 確認ボタンの前に「注意事項」のiframeのような要素を入れる
  $('.point .submit').before('<div class="point-attention-wrap"></div>');

  // 上記「注意事項」の中身を挿入する
  $('.point-attention-wrap').prepend('' +
    '<div class="attention point-attention">' +
      '<div class="attention__section">' +
        '<div class="attention__head-02">【注意事項】</div>' +
        '<div class="attention__item">ご応募は、お1人様1回限りとさせていただきます。</div>' +
        '<div class="attention__item">当選者の発表は1月16日12:00より姫路みたいサイト上、およびメールにてご案内いたします。</div>' +
        '<div class="attention__item">応募は日本国内にお住いの方に限らせていただきます。</div>' +
        '<div class="attention__item">第三者への譲渡は一切できません。</div>' +
        '<div class="attention__item">本企画の内容は予告なく変更、または終了させていただく場合があります。</div>' +
        '<div class="attention__item">本企画においてアクセス集中や通信回線の状態による遅延、不具合などにより発生したすべての事象につきましては、一切の責任は負いません。</div>' +
      '</div>' +
      '<div class="attention__section">' +
        '<div class="attention__head-02">【ご回答内容について】</div>' +
        '<div class="attention__item">ご入力いただいた皆様の個人情報やご回答内容は、処理・集計の目的以外では利用いたしません。また、分析結果の公表時等においてご回答者が特定されることはございません。</div>' +
        '<div class="attention__item">お預かりした個人情報は、当選商品発送および、個人を特定しない統計資料の作成の目的で使用させていただきます。</div>' +
      '</div>' +
      '<div class="attention__section">' +
        '<div class="attention__head-02">【商品の発送について】</div>' +
        '<div class="attention__item">商品の発送は国内に限らせていただきます。</div>' +
        '<div class="attention__item">諸事情により、商品の発送が多少遅れることがあります。</div>' +
        '<div class="attention__item">商品お届け日時の指定はできません。</div>' +
      '</div>' +
      '<div class="attention__section">' +
        '<div class="attention__head-02">【当選の無効について】</div>' +
        '<div class="attention__item">下記の場合、当選を無効とさせていただきますので、あらかじめご了承ください。</div>' +
        '<div class="attention__item">住所、氏名等記入漏れがある場合や記入内容に不備がある場合はご当選を無効とさせていただきます。</div>' +
        '<div class="attention__item">当選者の長期不在や商品お届け先住所や転居先が不明等の理由により商品がお届けできない場合は当選を無効とさせていただきます。</div>' +
        '<div class="attention__item">当選者の当選の権利を第三者へ譲渡することはできません。</div>' +
        '<div class="attention__item">応募に関して不正行為があった場合、当選を取り消させていただきます。</div>' +
        '<div class="attention__item">ご当選された商品は返品・交換はできません。</div>' +
        '<div class="attention__item">弊社が不正行為とみなす応募については全て無効とさせていただきます。</div>' +
      '</div>' +
      '<div class="attention__section">' +
        '<div class="attention__head-02">【個人情報の取り扱いについて】</div>' +
        '<div class="attention__item">お預かりした個人情報は、商品発送および、個人を特定しない統計資料の作成の目的で使用させていただきます。</div>' +
        '<div class="attention__item">また、その個人情報を、お客様の同意を得ないで業務委託先以外の第三者に開示・提示することはございません。（法令などにより開示・提示を認められた場合は除く）</div>' +
        '<div class="attention__item">詳しくは、当社の<a class="point-link" href="/privacy-policy.html">プライバシーポリシー</a>をご覧ください。</div>' +
      '</div>' +
      '<div class="attention__section">' +
        '<div class="attention__head-02">【お問合せ先】</div>' +
        '<div class="attention__item"><a class="point-link" href="/entry-form.html">姫路みたいお問い合わせフォーム</a>よりお問い合わせください。</div>' +
      '</div>' +
    '</div>'
    );

    $('.dl_point_name').hide();
    $('.dl_point_postalcode').hide();
    $('.dl_point_pref').hide();
    $('.dl_point_address').hide();

});
